import React from "react";
import { connect } from "react-redux";
import { formatNumber, formatNumberForceSigned } from "../../../lib/commonFunctions";

const PopulationBalance = ({ populationBalance }) => (
  <React.Fragment>
    <h3 className="title">Population growth</h3>

    {populationBalance.race
      ? <>Race bonus: <span className="positive">{formatNumberForceSigned(populationBalance.race)}</span><br/></> : ""}
    Buildings: <span className={`${populationBalance.buildings ? "positive" : ""}`}>{formatNumberForceSigned(populationBalance.buildings)}</span><br/>
    Magic: <span
    className={populationBalance.magic < 0 ? "negative" : "positive"}>{formatNumberForceSigned(populationBalance.magic)}</span><br/>
    Pops: <span
    className={populationBalance.pops < 0 ? "negative" : "positive"}>{formatNumberForceSigned(populationBalance.pops)}</span><br/>
    Food excess: <span
    className={populationBalance.food < 0 ? "negative" : "positive"}>{formatNumberForceSigned(populationBalance.food)}</span><br/>
    {populationBalance.general
      ? <>General: <span className="positive">{formatNumberForceSigned(populationBalance.general)}</span><br/></> : ""}
    {populationBalance.famine
      ? <>Food shortage: <span className="negative">{formatNumber(populationBalance.famine)}</span><br/></> : ""}
    {populationBalance.bankruptcy
      ? <>Bankruptcy: <span className="negative">{formatNumber(populationBalance.bankruptcy)}</span><br/></> : ""}
    Happiness: <span
    className={populationBalance.happiness < 0 ? "negative" : "positive"}>{formatNumberForceSigned(populationBalance.happiness)}</span><br/>
    {populationBalance.development
      ? <>Development: <span className="positive">{formatNumberForceSigned(populationBalance.development)}</span><br/></> : ""}
    {populationBalance.boost
      ? <>Population boost: <span className="positive">{formatNumberForceSigned(populationBalance.boost)}</span><br/></> : ""}
    {populationBalance.revolt
      ? <>Revolt: <span className="negative">{formatNumber(populationBalance.revolt)}</span><br/></> : ""}
    {populationBalance.revanchism
      ? <>Revanchism: <span className="positive">{formatNumberForceSigned(populationBalance.revanchism)}</span><br/></> : ""}
    {!!populationBalance.postWarBonus
      && <>Post war bonus: <span className="positive">{formatNumberForceSigned(populationBalance.postWarBonus)}</span><br/></>}
  </React.Fragment>
);

const mapStateToProps = state => ({
  populationBalance: state.governorate.resourceBalances.populationGrowth,
});

export default connect(mapStateToProps)(PopulationBalance);
